import { customAlphabet } from 'nanoid'
import { persistentAtom } from '@nanostores/persistent'
import { getGoogleAnalyticsData } from '../components/GoogleAnalyticsHiddenFields'

export const nanoid = customAlphabet('6789BCDFGHJKLMNPQRTWbcdfghjkmnpqrtwz', 14)

export const fingerprintId = persistentAtom('fingerprint', nanoid())

export const googleIdentity = () => {
  const googleAnalyticsData = getGoogleAnalyticsData()
  const phid =
    googleAnalyticsData.ga_clientid === 'undefined'
      ? fingerprintId.get()
      : googleAnalyticsData.ga_clientid
  window?.posthog && window.posthog?.identify(phid)
  return phid
}
